import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CardDetailsModalComponent } from '../card-details-modal/card-details-modal.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'forget-credentials-retail-modal',
	template: require('./forget-credentials-retail-modal.component.html'),
})
export class ForgetCredentialsRetailModalComponent {
	public isRebrading = AppSettings.isRebrading;

	constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) {}

	closeModal(): void {
		this.activeModal.close();
	}

	public continueToUsernameRecovery() {
		this.activeModal.close();
		const modalRef = this.modalService.open(CardDetailsModalComponent, {
			windowClass: 'modal-small',
		});
		(
			modalRef.componentInstance as CardDetailsModalComponent
		).isForgetCredentialsRetailModalflow = true;
	}
}
